<cdk-virtual-scroll-viewport
    class="cipo-selectable-listbox"
    role="listbox"
    tabindex="0"
    [itemSize]="itemSize"
    [minBufferPx]="itemSize * 5"
    [maxBufferPx]="itemSize * 10"
    [style.height]="height()"
    [style.maxHeight]="maxHeight()"
    [attr.aria-label]="ariaLabel() | translate"
    [attr.aria-multiselectable]="multiple() ? 'true' : null"
    [attr.aria-disabled]="disabled() ? 'true' : null"
    [attr.aria-activedescendant]="activeIndex() >= 0 ? optionId(activeIndex()) : null"
    (focus)="onFocus()"
    (keydown)="onKeydown($event)">
    <div
        *cdkVirtualFor="let row of rows(); trackBy: trackByRow; let rowIndex = index"
        class="cipo-selectable-listbox__row"
        [style.--cipo-listbox-columns]="columnCount()">
        @for (option of row; track option.key; let columnIndex = $index) {
            @let optionIndex = rowIndex * columnCount() + columnIndex;
            <div
                class="cipo-selectable-listbox__option"
                role="option"
                [id]="optionId(optionIndex)"
                [class.cipo-selectable-listbox__option--active]="activeIndex() === optionIndex"
                [class.cipo-selectable-listbox__option--selected]="isSelected(option.key)"
                [class.cipo-selectable-listbox__option--disabled]="disabled() || option.isDisabled"
                [attr.aria-selected]="isSelected(option.key)"
                [attr.aria-disabled]="disabled() || option.isDisabled ? 'true' : null"
                [attr.data-testid]="testId() ? testId() + '-' + option.key : null"
                tabindex="-1"
                [title]="option.value | translate"
                (click)="onOptionClick(optionIndex, option)"
                (keydown.enter)="onOptionClick(optionIndex, option)"
                (keydown.space)="onOptionClick(optionIndex, option)">
                @if (option.prefixIcon) {
                    <mat-icon aria-hidden="true" class="cipo-selectable-listbox__prefix">
                        {{ option.prefixIcon }}
                    </mat-icon>
                }
                <span class="cipo-selectable-listbox__label">{{ option.value | translate }}</span>
            </div>
        }
    </div>
</cdk-virtual-scroll-viewport>
